<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:10:20
-->
<template>
  <div class="bidItem" @click="goDetail">
    <div class="inner">
      <div class="top flex">
        <div class="left">
          {{ info.bizName.split("")[0] }}
        </div>
        <div class="right">
          <div class="bizName">{{ info.bizName || "--" }}</div>
          <div class="sgInfo">
            <span class="goodstype">{{ info.goodsType || "--" }}</span>
            <span class="goodsWeight">{{ info.goodsWeight || 0 }}吨</span>
          </div>
        </div>
        <div class="tips">
          <div class="tips">
            <p
              v-if="info.state == '1' || info.state == '2'"
              :class="['tipSpan', `tipSpan1`]"
            >
              <span>接单中</span>
            </p>
            <p v-if="info.state == '3'" :class="['tipSpan', `tipSpan3`]">
              <span>已接单</span>
            </p>
            <p v-if="info.state == '5'" :class="['tipSpan', `tipSpan4`]">
              <span>已打卡</span>
            </p>
            <p v-if="info.state == '6'" :class="['tipSpan', `tipSpan4`]">
              <span>已完单</span>
            </p>
            <p v-if="info.state == '4'" :class="['tipSpan', `tipSpan5`]">
              <span>已指派</span>
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="middle">
        <span class="orgin">始</span>
        <span class="tip">始发地：</span>
        <span class="place">{{info.originPlace}}</span>
        <img class="middleImg" src="../../../../assets/accountant/to.png">
        <span class="des">目</span>
        <span class="tip">目的地：</span>
        <span class="place">{{info.destinationPlace}}</span>
      </div> -->
      <div class="middle flex">
        <div class="left">
          <div>
            <p class="tip">始发地：</p>
            <p class="place">{{ info.originPlace || "--" }}</p>
          </div>
          <div>
            <p class="tip">目的地：</p>
            <p class="place">{{ info.destinationPlace || "--" }}</p>
          </div>
        </div>
      </div>
      <div class="info">
        <p><span>创建时间：</span>{{ info.createTime || "--" }}</p>
        <p v-if="info.type != '1'">
          <span>接单时间：</span>{{ info.takeOrderTime || "--" }}
        </p>
        <p v-if="info.type != '1'">
          <span>接单人：</span>{{ info.acceptPerson || "--" }}
        </p>
      </div>
    </div>
    <div class="type">
      <!-- <span
        class="type4"
        @click="renewal(info)"
        v-if="info.state == 3 || info.state == 4"
      >
        更换安装人员</span
      > -->

      <span class="type3" v-if="info.state == 2" @click="changetype(3)"
        >已退回</span
      >
      <span
        class="type2"
        v-if="info.state == 3 || info.state == 4"
        @click="changetype(1)"
        >提醒</span
      >
      <span
        class="type1"
        v-if="info.state == 1 || info.state == 2"
        @click="changetype(2)"
        >指派</span
      >
      <span class="type2" v-if="info.state == 5" @click="changetype(5)"
        >打卡信息</span
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "bidItem",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  //  1,待接单,2 退回状态  3 已接单  4 已指派  5 已打卡 6 已完单
  data() {
    return {
      tableList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    changetype(methods) {
      this.$emit("action", this.info, methods);
    },
    renewal(e) {
      console.log(e, "变更");
      this.$router.push({
        path: "/dispatch/order/replacement",
        query: { info: JSON.stringify(e) },
      });
    },
      goDetail() {
          //  1,待接单,2 退回状态  3 已接单  4 已指派  5 已打卡 6 已完单
           if ([1, 2].indexOf(this.info.state) > -1) return;
          this.$router.push({
              path: "/workOrder/order/detail",
              query: { info: JSON.stringify(this.info),role: 5 },
          });
      },
  },
};
</script>

<style lang="less" scoped>
.bidItem {
  width: 96%;
  min-height: 200px;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 10px;
  padding: 0 15px;
  .inner {
    padding: 15px 0;
    .top {
      margin-bottom: 13px;
      position: relative;
      .tips {
        position: absolute;
        right: 2px;
        .tipSpan {
          display: block;
          text-align: center;
          width: 60px;
          height: 20px;
          color: #fff;
          position: relative;
          &::before {
            position: absolute;
            content: "";
            display: block;
            width: 100%;
            height: 100%;
            transform: skew(-15deg, 0);
            background-color: #333;
            top: 0;
            left: 0;
            border-radius: 3px;
          }
          span {
            display: block;
            width: 100%;
            height: 100%;
            line-height: 20px;
            position: relative;
            font-size: 12px;
          }
          &1 {
            &::before {
              background: linear-gradient(-87deg, #fcbe73 0%, #fc9642 100%);
            }
          }
          &3 {
            &::before {
              background: linear-gradient(-87deg, #fcbe73 0%, #fc9642 100%);
            }
          }
          &5 {
            &::before {
              background: linear-gradient(-87deg, #52c5ff 0%, #508aed 100%);
            }
          }
          &4 {
            &::before {
              background: linear-gradient(-87deg, #61cda9 0%, #29b27a 100%);
            }
          }
        }
      }
      .left {
        flex: 0 0 40px;
        height: 40px;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        background: #44b1f9;
        border-radius: 6px;
        color: #fff;
        margin-right: 10px;
      }
      .bizName {
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        padding: 2px 0;
        line-height: 16px;
        margin-bottom: 2px;
      }
      .sgInfo {
        span {
          display: inline-block;
          padding: 2px 5px;
          font-size: 12px;
          line-height: 1.1;
        }
        .goodstype {
          margin-right: 10px;
          background: rgba(31, 181, 74, 0.15);
          color: #1fb54a;
        }
        .goodsWeight {
          margin-right: 10px;
          background: rgba(255, 0, 0, 0.15);
          color: #ff0000;
        }
      }
    }
    // .middle{
    //   display: inline-block;
    //   vertical-align: middle;
    //   height: 28px;
    //   background: rgba(68,177,249,0.06);
    //   border-radius: 5px;
    //   line-height: 28px;
    //   padding: 0 15px;
    //   color: #333;
    //   margin-bottom: 15px;
    //   span,img{
    //     display: inline-block;
    //     vertical-align: middle;
    //     font-size: 13px;
    //   }
    //   img{
    //     width: 23px;
    //     margin: 0 15px;
    //   }
    //   .orgin{
    //     width: 16px;
    //     height: 16px;
    //     text-align: center;
    //     font-size: 12px;
    //     line-height: 16px;
    //     background-color: rgba(255,0,0,0.24);
    //     border-radius: 2px;
    //     color: #ff0101;
    //     margin-right: 5px;
    //   }
    //   .des{
    //     width: 16px;
    //     height: 16px;
    //     text-align: center;
    //     font-size: 12px;
    //     line-height: 16px;
    //     background-color: rgba(100,198,123,0.24);
    //     border-radius: 2px;
    //     color: #64c67b;
    //     margin-right: 5px;
    //   }
    //   .tip{
    //     color: #999;
    //     margin-right: 5px;
    //   }

    // }
    .middle {
      vertical-align: middle;
      border-radius: 5px;
      color: #333;
      margin-bottom: 15px;
      align-items: center;
      justify-content: space-between;
      .left {
        background: url("../../../../assets/workOrder/itemLeft.png") left center
          no-repeat;
        background-size: 8px 44px;
        min-height: 44px;
        padding-left: 15px;
        > div:first-child {
          margin-bottom: 6px;
        }
        .tip,
        .place {
          display: inline-block;
          vertical-align: middle;
          font-size: 13px;
          line-height: 28px;
        }
        .tip {
          color: #999;
          margin-right: 5px;
        }
        .place {
          font-weight: bold;
          color: #000;
        }
      }
      .right {
        flex: 0 0 40px;
        text-align: center;
        .rightIcon {
          display: block;
          width: 32px;
          height: 32px;
          margin: 0 auto 6px;
        }
        .rightText {
          font-size: 13px;
          color: #44b1f9;
          font-weight: 500;
        }
      }
    }
    .info {
      p {
        font-size: 13px;
        line-height: 2;
        color: #333;
        span {
          color: #999;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
  }
  .type {
    border-top: 1px solid #eeeeee;
    padding: 15px 0;
    text-align: right;
    .type2 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: rgba(68, 177, 249, 0.15);
      border: 1px solid #44b1f9;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #44b1f9;
      line-height: 26px;
      margin-right: 5px;
    }
    .type1 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: #44b1f9;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 26px;
    }
    .type3 {
      display: inline-block;
      height: 26px;
      border: 1px solid #999;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #999;
      line-height: 26px;
      margin-right: 10px;
      padding: 0 15px;
      background: rgba(153, 153, 153, 0.15);
    }
    .type4 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: rgba(252, 152, 68, 0.15);
      border: 1px solid #fc9c49;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fc9c49;
      line-height: 26px;
      margin-right: 5px;
    }
  }
}
</style>